import { useMutation } from "react-query";
import { clientsApi } from "frontend/src/api/clients";
import { notify } from "frontend/src/features/notifications";
import { queryClient } from "frontend/src/domain/query-client";
import { clientsCacheKey } from "./shared";
export var useCreateClient = function () {
    return useMutation(clientsApi.create, {
        onSuccess: function () {
            notify({ variant: "success", message: "Клиент создан." });
        },
        onSettled: function () { return queryClient.invalidateQueries(clientsCacheKey); },
    });
};
